module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./BillListView.js"));
	}, "BillListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BillListView!./src/pages/Shop/Member/Wallet/Bill/BillList/BillListView.js
// module id = 1576
// module chunks = 418